import React, { PureComponent } from 'react';
import Link from 'gatsby-link';

import './navbar.css';

const getScrollTop = () =>
  document.documentElement.scrollTop ||
  document.body.scrollTop ||
  window.pageYOffset ||
  0;

export default class Navbar extends PureComponent {
  menuOpen = false;
  bodyScroll = 0;

  state = {
    navHeight: '100vh'
  };

  componentDidMount() {
    window.addEventListener('resize', this.setNavHeight);
    this.setNavHeight();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setNavHeight);
  }

  setNavHeight = () => {
    this.setState({ navHeight: window.innerHeight });
  };

  toggleMenu = () => {
    this.menuOpen = !this.menuOpen;
    this.setBodyClass();
  };

  setBodyClass = () => {
    if (this.menuOpen) {
      this.bodyScroll = getScrollTop();
      console.log();
      document.body.classList.add('menu-open');
      document.body.style.top = -this.bodyScroll + 'px';
    } else {
      document.body.classList.remove('menu-open');
      document.body.style.top = 0;
      document.body.scrollTop = this.bodyScroll;
    }
  };

  closeMenu = () => {
    this.menuOpen = false;
    this.setBodyClass();
  };

  render() {
    const {
      portfolioUrl,
      shopUrl,
      instagramUrl,
      facebookUrl,
      pinterestUrl
    } = this.props;

    const { navHeight } = this.state;

    return (
      <div className="navbar">
        <div className="menu mobile" onClick={this.toggleMenu} />

        <header className="mobile">
          <Link to="/">
            <img
              className="small-logo"
              src="/images/small-logo.png"
              srcSet="/images/small-logo@2x.png 2x"
              alt="Logo Les Plumes"
            />
          </Link>
          <a
            className="instagram"
            href={instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/images/insta.png"
              srcSet="/images/insta@2x.png 2x"
              alt="Instagram"
            />
          </a>
        </header>
        <nav onClick={this.closeMenu} style={{ height: navHeight }}>
          <Link to="/">
            <img
              className="logo"
              src="/images/logo-les-plumes.png"
              srcSet="/images/logo-les-plumes@2x.png 2x"
              alt="Logo Les Plumes"
            />
          </Link>
          <a
            className="emma"
            href={portfolioUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Book
          </a>
          <Link className="emma" to="/amelie">
            Amélie
          </Link>
          <a
            className="emma"
            href={shopUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Shop
          </a>
          <div className="spacer" />
          <div className="social-icons">
            <a href={instagramUrl} target="_blank" rel="noopener noreferrer">
              <img
                src="/images/insta.png"
                srcSet="/images/insta@2x.png 2x"
                alt="Instagram"
              />
            </a>
            <a href={facebookUrl} target="_blank" rel="noopener noreferrer">
              <img
                src="/images/fb.png"
                srcSet="/images/fb@2x.png 2x"
                alt="Facebook"
              />
            </a>
            <a href={pinterestUrl} target="_blank" rel="noopener noreferrer">
              <img
                src="/images/pin.png"
                srcSet="/images/pin@2x.png 2x"
                alt="Pinterest"
              />
            </a>
          </div>
        </nav>
      </div>
    );
  }
}

export const query = graphql`
  fragment NavbarFragment on DatoCmsPersonalInformation {
    shopUrl
    portfolioUrl
    instagramUrl
    facebookUrl
    pinterestUrl
  }
`;



// WEBPACK FOOTER //
// ./src/components/navbar.js